/**
 * The Forum action: take any one face-up forum tile, or one of the three
 * extra-action tiles on the yellow spaces, onto the player's mat. The space
 * stays empty until the quarter-end refill.
 */
import { afterAction, fail, succeed, updatePlayer } from '../internal.js';
export function forumOptions(board) {
    const out = [];
    board.forum.forEach((t, index) => t && out.push({ from: 'forum', index }));
    board.yellowSpaces.forEach((t, index) => t && out.push({ from: 'yellow', index }));
    return out;
}
export function takeForumTile(state, actor, payload) {
    const p = payload;
    if (!p || (p.from !== 'forum' && p.from !== 'yellow') || typeof p.index !== 'number') {
        return fail('ILLEGAL', "Forum action needs { from: 'forum' | 'yellow', index }");
    }
    const events = [];
    let next;
    if (p.from === 'forum') {
        const tile = state.board.forum[p.index];
        if (tile === undefined)
            return fail('ILLEGAL', `no forum space ${p.index}`);
        if (tile === null)
            return fail('ILLEGAL', `forum space ${p.index} is empty`);
        const forum = state.board.forum.map((t, i) => (i === p.index ? null : t));
        next = updatePlayer({ ...state, board: { ...state.board, forum } }, actor, (pl) => ({
            ...pl,
            forumTiles: [...pl.forumTiles, tile],
        }));
        events.push({ type: 'ForumTileTaken', player: actor, tileId: tile.id, kind: tile.kind });
    }
    else {
        const tile = state.board.yellowSpaces[p.index];
        if (tile === undefined)
            return fail('ILLEGAL', `no yellow space ${p.index}`);
        if (tile === null)
            return fail('ILLEGAL', `yellow space ${p.index} is empty`);
        const yellowSpaces = state.board.yellowSpaces.map((t, i) => (i === p.index ? null : t));
        next = updatePlayer({ ...state, board: { ...state.board, yellowSpaces } }, actor, (pl) => ({
            ...pl,
            extraActionTiles: [...pl.extraActionTiles, tile],
        }));
        events.push({
            type: 'ExtraActionTileTaken',
            player: actor,
            tileId: tile.id,
            action: tile.action,
        });
    }
    return succeed(afterAction(next), events);
}
//# sourceMappingURL=forum.js.map